module.exports = __webpack_public_path__ + "img/profit-and-loss-1024x611.f82acecb.png";